import React, { useState } from "react";
import {
  Progress,
  Module,
  Total_Points_Gained_Core,
  Total_Points_Gained_Flex,
} from "resources/constants/strings.js";
import { Block } from "baseui/block";
import { StatefulTooltip } from "baseui/tooltip";
import { useStyletron } from "baseui";
import ProgressBar from "components/progress";
import MicroBadge from "../../TrackSummary/components/badges/microBadge";
import BadgeModal from '../../TrackSummary/components/badges/badgeModal'
import InfoIcon from "assets/images/info-icon.png";

const BLOCK_STYLE = (theme) => ({
  backgroundColor: "white",
  borderRadius: "8px",
  border: `1px solid ${theme.RAColors?.gray200}`,

  [theme.mediaQuery.small]: {
    padding: "16px",
  },
  [theme.mediaQuery.medium]: {
    padding: "24px",
  },
});

const TOTAL_POINTS = (theme) => ({
  backgroundColor: "white",
  borderRadius: "8px",
  border: `1px solid ${theme.RAColors?.gray200}`,
  [theme.mediaQuery.medium]: {
    padding: "24px",
  },
  [theme.mediaQuery.small]: {
    width:"100%",
    padding: "16px",
    display:"block"
  },
  [theme.mediaQuery.large]: {
    padding: "16px",
    width:"auto",
    display:"inherit"
  }
});

const TITLE_STYLE =(theme) => ({
  fontFamily: "Manrope-Bold",
  fontSize: "24px",
  lineHeight: "33px",
  marginBottom: "20px",
  [theme.mediaQuery.small]: {
    fontSize: "18px",
    display: "inline"
  },
  [theme.mediaQuery.large]: {
    fontSize: "24px",
    display:"inherit"
  },
});
const TITLE_WHOLE_SECTION =(theme) => ({
  [theme.mediaQuery.small]: {
    marginBottom: "20px"
  },
});

const ITEM_TITLE_STYLE = (theme) => ({
  fontFamily: "Manrope-Semibold",
  fontSize: "14px",
  lineHeight: "19px",
  marginBottom: "4px",
  color: theme?.RAColors?.gray800,
});

const ITEM_CONTENT_STYLE = (theme) => ({
  fontFamily: "Epilogue-Medium",
  fontSize: "28px",
  lineHeight: "40px",
  color: theme?.RAColors?.gray800,
});

const TOTAL_POINTS_GAINED_BLOCK = (theme) => ({
  [theme.mediaQuery.small]: {
    margin:"0px 70px 0px 70px",
  },
  [theme.mediaQuery.medium]: {
    margin:"0px 0px 0px 0px"
  },
  [theme.mediaQuery.large]: {
    margin:"0px 0px 0px 0px"
  },
})
const Summary = ({ assignments = {} }) => {
  const [css, theme] = useStyletron();
  const [activeBadge, setActiveBadge] = useState(null);
  
  return (
    <Block className={css(BLOCK_STYLE(theme))} marginBottom={["16px", "16px","20px"]}>
      <Block className={css(TITLE_WHOLE_SECTION(theme))} display="inline-block" >
        <Block as="h3" className={css((TITLE_STYLE(theme)))} marginRight="5px" data-testid="assignment_name">
          {Module} : {assignments?.course_name}
        </Block>
        <StatefulTooltip
          accessibilityType={"tooltip"}
          content=""
          showArrow
          placement="top"
        >
          <Block data-testid="info-image" as="img" src={InfoIcon} alt="info Icon" />
        </StatefulTooltip>
      </Block>  
      
      <Block display="flex" flexWrap="wrap" gridGap="12px" alignItems="center">
        <Block paddingLeft="10px" paddingRight="10px" data-testid="lesson-image">
          <MicroBadge
            width="62px"
            name={assignments?.course_image}
            isFaded={(assignments?.course_progress?.progress_actual || 0) < 100}
          />
        </Block>
        <Block className={css({ ...BLOCK_STYLE(theme), padding: "16px" })}>
          <Block className={css(ITEM_TITLE_STYLE(theme))} data-testid="progress_text">{Module + " " + Progress}</Block>
          <Block display="flex" gridGap="16px" alignItems="center">
            <Block className={css(ITEM_CONTENT_STYLE(theme))} data-testid="progress_trackbar">
              {assignments?.course_progress?.progress_actual ||
                0}
              %
            </Block>
            <Block width="100px">
              <ProgressBar
                value={
                  assignments?.course_progress?.progress_actual || 0
                }
                targetValue={
                  assignments?.course_progress?.progress_expected
                }
              />
            </Block>
          </Block>
        </Block>
        <Block
          display="flex"
          flexDirection="row"
          gridGap="20px"
          className={css(TOTAL_POINTS(theme))}
        >
          <Block className={css(TOTAL_POINTS_GAINED_BLOCK(theme))}>
            <Block data-testid="total_points_core" className={css(ITEM_TITLE_STYLE(theme))}>
              {Total_Points_Gained_Core}
            </Block>
            <Block className={css(ITEM_CONTENT_STYLE(theme))}>
              {assignments?.course_skill_points_actual}
              {"/"}
              {assignments?.course_skill_points_total}
            </Block>
          </Block>

          <Block className={css(TOTAL_POINTS_GAINED_BLOCK(theme))}>
            <Block data-testid="total_points_flex" className={css(ITEM_TITLE_STYLE(theme))}>
              {Total_Points_Gained_Flex}
            </Block>
            <Block className={css(ITEM_CONTENT_STYLE(theme))} data-testid="skill_point_actual">
              {assignments?.course_flex_skill_points_actual}
            </Block>
          </Block>


        </Block>
      </Block>

      {activeBadge && <BadgeModal badge={activeBadge} close={() => setActiveBadge(null)} />}
    </Block>
  );
};

export default Summary;
